import { useMemo } from "react";
import type { ReactNode } from "react";
import { plgTalentServices } from "plg/api/plgTalentApi";
import { getPlgProfile } from "plg/auth/plgTokenStore";
import { HIRE_ROUTES, hireTalentProfile } from "plg/routes";
import type { TalentApi } from "components/Screens/Marketplace/Customer/TalentApiContext";

export default function usePlgTalentApi(renderAccountMenu?: () => ReactNode): TalentApi {
  const profile = getPlgProfile();
  return useMemo<TalentApi>(() => {
    const permissions = new Set(profile?.permissions || []);
    const name = [profile?.firstName, profile?.lastName].filter(Boolean).join(" ") || profile?.companyName || "";
    return {
      kind: "plg",
      user: profile
        ? { customerId: profile.plgCustomerId, userId: profile.plgCustomerId, name, email: profile.email, type: "plg" }
        : null,
      hasPermission: (key: string) => permissions.has(key),
      routes: {
        home: HIRE_ROUTES.home,
        talentNetwork: HIRE_ROUTES.talentNetwork,
        talentProfile: hireTalentProfile,
        requestAHire: HIRE_ROUTES.requestAHire,
        shortlist: HIRE_ROUTES.shortlist,
        interviewStatus: HIRE_ROUTES.interviewStatus,
      },
      customerState: profile?.state,
      talentNetworkVisible: true,
      userInfoLoading: false,
      renderAccountMenu,
      ...plgTalentServices,
    };
    // profile is re-read on every render; recompute when its identity-bearing fields change
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profile?.plgCustomerId, profile?.state, profile?.firstName, profile?.isVerified, (profile?.permissions || []).join(","), renderAccountMenu]);
}
